export default __webpack_public_path__ + "static/media/touche.74cd7fd8.gif";